(() => {
    "use strict";
    var t = new ((function () {
        function t() {
            var t = this;
            this.test = false;
            this.sensors = null;
            (this.timer = null),
                (this.canceled = false),
                (this.system = "WUES"),
                (this.sv = "1.0.0"),
                (this.id = Math.random().toString(36).substr(2, 4)),
                (this.embedCommInfo = ""),
                (this.initData = {}),
                (this.commonTrackData = {}),
                (this.config = {
                    width: 320,
                    height: 0,
                    limitH: 0,
                    pos: {
                        left: 0,
                        right: 0,
                        bottom: 0,
                        top: 0,
                    },
                    embed: "web",
                    lang: "en",
                    theme: "dark",
                    url: location.href,
                }),
                (this.setting = {
                    closed: {
                        src: "about:blank",
                        opacity: "0",
                        transition: "none",
                        zIndex: "-1",
                        pointerEvents: "none",
                    },
                    opened: {
                        src: "about:blank",
                        opacity: "1",
                        transition: "opacity .3s ease-out, height .1s ease-out",
                        zIndex: "50",
                        pointerEvents: "auto",
                    },
                }),
                this.initIframe();
            this.initTrack();
            window.addEventListener(
                "message",
                function (e) {
                    if (e.data && e.data.action) {
                        var i = e.data.action;
                        t.embedCommInfo = e.data;
                        t.iframe.dispatchEvent(new CustomEvent("iframe", { detail: e.data }));
                        switch (i) {
                            case "WS_APP_READY":
                                t.iframe.dispatchEvent(
                                    new CustomEvent("popup", {
                                        detail: { status: "popup" },
                                    })
                                );
                                break;
                            case "WS_APP_SUBMIT":
                                break;
                            case "WS_APP_CLOSE_WINDOW":
                                t.close();
                                break;
                            case "WS_APP_RESIZE":
                                "WS_APP_RESIZE" === i && t.resizeH(!t.config.limitH ? e.data.params.page.height : t.config.limitH);
                                break;
                        }
                    }
                },
                !1
            );
        }
        return (
            (t.prototype.popup = function (d) {
                d.src && (this.setting.opened.src = d.src);
                d.lh && (this.config.limitH = d.lh);
                d.h && (this.config.height = d.h);
                d.w && (this.config.width = d.w);
                d.pos && (this.config.pos = d.pos);
                d.bg && (this.config.bg = d.bg || "transparent");
                this.resetTimeout(),
                    (this.timer = setTimeout(
                        () => {
                            this.closeIframe();
                            !this.canceled && this.openIframe();
                            this.timer = null;
                        },
                        d.delay ? d.delay * 1000 : 0
                    ));
            }),
            (t.prototype.close = function () {
                this.resetTimeout(), this.iframe.dispatchEvent(new CustomEvent("close", { detail: { status: "close" } })), this.closeIframe();
            }),
            (t.prototype.on = function (t, e) {
                this.iframe.addEventListener(t, function (t) {
                    return e(t);
                });
            }),
            (t.prototype.log = function (t) {
                console.log("[" + this.system + "]" + t);
            }),
            (t.prototype.resizeH = function (h) {
                this.iframe.style.height = h + "px";
            }),
            (t.prototype.getEmbedCommInfo = function () {
                return this.embedCommInfo;
            }),
            (t.prototype.initTrack = function () {
                // if (!this.sensors) {
                //   this.sensors = window["sensorsDataAnalytic201505"];
                //   this.sensors &&
                //     this.sensors.init({
                //       server_url:
                //         "https://analytics.wondershare.cc:8106/sa?project=" +
                //         (this.test ? "UA_NPS20_Web_test" : "UA_NPS20_Web"),
                //       is_track_single_page: true,
                //       use_client_time: true,
                //       send_type: "beacon",
                //       heatmap: {
                //         clickmap: "not_collect",
                //         scroll_notice_map: "not_collect",
                //       },
                //       show_log: this.test,
                //     });
                // }
                return this.sensors;
            }),
            (t.prototype.initIframe = function () {
                (this.iframe = document.createElement("iframe")),
                    (this.iframe.id = this.system + "-dom"),
                    (this.iframe.name = this.system),
                    (this.iframe.dataset.id = this.id),
                    (this.iframe.width = this.config.width),
                    (this.iframe.height = this.config.height),
                    (this.iframe.scrolling = "auto"),
                    (this.iframe.style.border = "none"),
                    (this.iframe.style.backgroundColor = "transparent"),
                    (this.iframe.style.position = "fixed"),
                    (this.iframe.style.bottom = "24px"),
                    (this.iframe.style.right = "24px"),
                    (this.iframe.style.boxShadow = "0px 8px 24px 0px rgba(0, 0, 0, 0.16)"),
                    (this.iframe.style.maxWidth = "100%"),
                    (this.iframe.style.maxHeight = "100%"),
                    (this.iframe.style.borderRadius = "8px"),
                    (this.iframe.style.overflow = "hidden"),
                    (this.iframe.style.transition = "opacity .3s ease-out, height .1s ease-out"),
                    document.body.appendChild(this.iframe);
            }),
            (t.prototype.openIframe = function () {
                if (!this.setting.opened.src) return;
                (this.iframe.src = this.setting.opened.src),
                    (this.iframe.style.opacity = this.setting.opened.opacity),
                    (this.iframe.style.transition = this.setting.opened.transition),
                    (this.iframe.style.zIndex = this.setting.opened.zIndex),
                    (this.iframe.style.pointerEvents = this.setting.opened.pointerEvents);
                this.iframe.style.width = this.config.width + "px";
                this.iframe.style.height = this.config.height + "px";
                if (this.config.pos) {
                    this.iframe.style.top = "initial";
                    this.iframe.style.bottom = "initial";
                    this.iframe.style.left = "initial";
                    this.iframe.style.right = "initial";
                    this.iframe.style.transform = "initial";
                    switch (this.config.pos.display_position) {
                        case "bottom_right":
                            this.iframe.style.right = this.config.pos.right + "px";
                            this.iframe.style.bottom = this.config.pos.bottom + "px";
                            break;
                        case "bottom_left":
                            this.iframe.style.left = this.config.pos.left + "px";
                            this.iframe.style.bottom = this.config.pos.bottom + "px";
                            break;
                        case "bottom":
                            this.iframe.style.bottom = (this.config.pos.bottom || 0) + "px";
                            this.iframe.style.left = "50%";
                            this.iframe.style.transform = "translate(-50%, 0%)";
                            break;
                        case "top_right":
                            this.iframe.style.right = this.config.pos.right + "px";
                            this.iframe.style.top = this.config.pos.top + "px";
                            break;
                        case "top_middle":
                            this.iframe.style.top = this.config.pos.top + "px";
                            this.iframe.style.left = "50%";
                            this.iframe.style.transform = "translate(-50%, 0%)";
                            break;
                        case "middle":
                            this.iframe.style.left = "50%";
                            this.iframe.style.top = "50%";
                            this.iframe.style.transform = "translate(-50%, -50%)";
                            break;
                        case "embed":
                            break;
                    }
                }
            }),
            (t.prototype.closeIframe = function () {
                (this.iframe.src = this.setting.closed.src),
                    (this.iframe.style.opacity = this.setting.closed.opacity),
                    (this.iframe.style.transition = this.setting.closed.transition),
                    (this.iframe.style.zIndex = this.setting.closed.zIndex),
                    (this.iframe.style.pointerEvents = this.setting.closed.pointerEvents);
            }),
            (t.prototype.resetTimeout = function () {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
            }),
            (t.prototype.cancel = function () {
                this.canceled = true;
            }),
            (t.prototype.track = function (t, d) {
                this.sensors && this.sensors.track(t, d);
            }),
            t
        );
    })())();
    function ajaxRequest(url, method, token, data, successCallback, errorCallback, timeout) {
        const baseUrl = "https://prod-web.wondershare.cc";
        const apiUrl = url;
        const xhr = new XMLHttpRequest();
        if (data && method === "GET") {
            var params = [];
            Object.keys(data).forEach((key) => {
                if (data[key] !== undefined && data[key] !== null && data[key] !== "") params.push(key + "=" + data[key]);
            });
            url += "?" + params.join("&");
        }
        xhr.timeout = timeout || 5000;
        xhr.open(method, baseUrl + url, true);
        xhr.setRequestHeader("Content-Type", "application/json");
        // xhr.setRequestHeader("Authorization", "Bearer " + token);

        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 400) {
                const response = JSON.parse(xhr.responseText);
                successCallback && successCallback(response, apiUrl);
            } else {
                const response = xhr.responseText ? JSON.parse(xhr.responseText) : { msg: "Network error" };
                errorCallback && errorCallback(response, apiUrl);
            }
        };

        xhr.onerror = function () {
            errorCallback && errorCallback({ msg: "Network error" }, apiUrl);
        };

        xhr.ontimeout = function () {
            errorCallback && errorCallback({ msg: "timeout of " + xhr.timeout + "ms exceeded" }, apiUrl);
        };

        xhr.send(JSON.stringify(data));
    }
    function getSearch(url) {
        const search = url.split("?")[1];
        const searchObj = {};
        if (search) {
            search.split("&").forEach((item) => {
                const [key, value] = item.split("=");
                searchObj[key] = value;
            });
        }
        return searchObj;
    }
    const themeMap = {
        dark: 1,
        light: 2,
    };
    const typeMap = {
        1: "鏅€氶棶鍗�",
        2: "nps",
        3: "csat",
    };
    const uiMap = {
        0: "default",
        1: "Filmora",
        2: "Virbo",
        3: "fx_export_ui",
    };
    window.WUES = {
        popup: function (d) {
            t.initData = d;
            t.commonTrackData = {
                plang: d.lang,
                survey_colormode: d.theme,
                tid: "UA_NPS20_Web",
                uid: d.source.uid,
                user_type: d.source.ut,
                pid: d.source.pid,
                pver: d.source.pv,
                psource: d.source.ps,
                sdk_ver: t.sv,
                survey_place: d.sp,
                survey_scence: d.source.scene,
                extra: d.source.c,
            };
            this.cancel = false;
            ajaxRequest(
                "/api/v1/prodweb/questionnaire/push/detail",
                "GET",
                d.token,
                Object.assign(
                    {
                        lang: d.lang,
                        color: themeMap[d.theme],
                        topBar: d.topBar === false ? 0 : 1,
                        close: d.closeBtn === false ? 0 : 1,
                    },
                    d.source
                        ? {
                              pid: d.source.pid,
                              scene_mark: d.source.scene,
                              wsid: d.source.uid,
                              did: d.source.did,
                              user_type: d.source.ut,
                              pver: d.source.pv,
                              psource: d.source.ps,
                              display_position: d.sp,
                              sdk_ver: t.sv,
                          }
                        : {}
                ),
                function (response, apiUrl) {
                    const info = response.code === 0 ? response.data : undefined;
                    const w = t.initData.w >= 280 ? t.initData.w : 320;
                    const lh = t.initData.h || 0;
                    if (info) {
                        const src = info.h5_url;
                        const delay = info.stay_on_time || 0;
                        var pos = info.pos;
                        if (t.initData.sp) {
                            for (var i = 0; info.pos_list.length > i; i++) {
                                info.pos_list[i].display_position === t.initData.sp && (pos = info.pos_list[i]);
                            }
                        }
                        pos =
                            t.initData.pos && t.initData.sp
                                ? {
                                      display_position: t.initData.sp,
                                      bottom: t.initData.pos.bottom,
                                      top: t.initData.pos.top,
                                      left: t.initData.pos.left,
                                      right: t.initData.pos.right,
                                  }
                                : pos;
                        t.popup({ w, lh, pos, src, delay });
                        const search = getSearch(info.h5_url);
                        t.commonTrackData.survey_id = search.qid;
                        t.commonTrackData.survey_type = typeMap[search.type];
                        t.commonTrackData.survey_ui = uiMap[search.ui];
                        t.commonTrackData.survey_colormode = t.commonTrackData.survey_colormode || search.theme;
                        t.track(
                            "SDK_APIrequest",
                            Object.assign(
                                {
                                    request_result: true,
                                    api_name: apiUrl,
                                },
                                t.commonTrackData
                            )
                        );
                    } else {
                        t.track(
                            "SDK_APIrequest",
                            Object.assign(
                                {
                                    request_result: false,
                                    api_name: apiUrl,
                                    error_code: response.code,
                                    error_info: response.msg,
                                },
                                t.commonTrackData
                            )
                        );
                    }
                },
                function (error, apiUrl) {
                    t.track(
                        "SDK_APIrequest",
                        Object.assign(
                            {
                                request_result: false,
                                api_name: apiUrl,
                                error_code: error.code,
                                error_info: error.msg,
                            },
                            t.commonTrackData
                        )
                    );
                }
            );
            return t;
        },
        close: function () {
            t.cancel();
            return t.close();
        },
        on: function (e, i) {
            return t.on(e, i);
        },
        getEmbedCommInfo: function () {
            return t.getEmbedCommInfo();
        },
    };
})();
